export const profileRoutes = [
    {
        path: "/personal",
        name: "Personal",
        component: () => import(/* webpackChunkName: "LK" */ "@/ThePersonal/index"),
        children: [
            {
                name: "ThePersonalMain",
                path: "/personal",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_M" */ "@/ThePersonal/routes/ThePersonalMain"
                    ),
            },
            {
                name: "ThePersonalDiscounts",
                path: "/personal/discounts",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_D" */ "@/ThePersonal/routes/ThePersonalDiscounts"
                    ),
            },
            {
                name: "ThePersonalData",
                path: "/personal/data",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_Da" */ "@/ThePersonal/routes/ThePersonalData"
                    ),
            },
            {
                name: "ThePersonalOrders",
                path: "/personal/orders",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_O" */ "@/ThePersonal/routes/ThePersonalOrders"
                    ),
            },
            {
                name: "ThePersonalAddresses",
                path: "/personal/addresses",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_A" */ "@/ThePersonal/routes/ThePersonalAddresses"
                    ),
            },
            {
                name: "ThePersonalBonuses",
                path: "/personal/bonuses",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_B" */ "@/ThePersonal/routes/ThePersonalBonuses"
                    ),
            },
            {
                name: "ThePersonalSupport",
                path: "/personal/support",
                component: () =>
                    import(
                        /* webpackChunkName: "LK_S" */ "@/ThePersonal/routes/ThePersonalSupport"
                    ),
            },
        ],
    },
    {
        path: "/madcoins",
        name: "Madcoins",
        component: () => import(/* webpackChunkName: "Mdcns" */ "@/pages/Madcoins"),
    },
    {
        path: "/document-loyalty",
        name: "DocumentLoyalty",
        component: () =>
            import(/* webpackChunkName: "D_Lty" */ "../pages/DocumentLoyalty.vue"),
    },
    {
        path: "/document-loyalty-faq",
        name: "DocumentLoyaltyFaq",
        component: () =>
            import(/* webpackChunkName: "D_Faq" */ "../pages/DocumentLoyaltyFaq.vue"),
    },
];
